<template lang="pug">
  .home
    .container(:class="[{'active': active} ]" :style="`padding: 0 ${pxToRem(40+resize.safePadding*0.5)}`")
      .up
        sys-bar
        .header
          .logo-wrapper
            logo-icon(ref="logoIcon")
            logo(ref="logo")
          home-avatar(ref="avatar")
      .bottom
        .content
          .card.reservation
            res-card(ref="resCard" @res="onRes")
          .slides
            home-slides(ref="homeSlides")
    popup-single(title="到支付宝空间站体验，即可解锁“我的足迹”更多精彩内容" v-if="ageWarning&&!ageWarningShowed" @yes="onConfirm")   
    popup-single(title="授权成功，请点击“立即预约” 选择预约时段，开启我们的奇妙之旅吧！" v-if="authSuccess" @yes="onConfirm2" )        
    //Loading(v-if="!loaded" ref="loading")
    //- popup-single(title="本购票服务仅对年满十八周岁的人士开放" v-if="ageWarning&&!ageWarningShowed" @yes="onAgeConfirm")
    // popup-single(title="7月10日（周六）森林TALK公益讲座火热预约中，席位限量，快来报名吧~" v-if="ageWarning&&!ageWarningShowed" @yes="onAgeConfirm")
    custom-service
    queue-panel
    inv-popup(v-if="showInvPopup" @accepted="onInvAccepted" @rejected="onInvRejected")
    latest-res-popup(v-if="showLatestResPopup")

</template>

<script>
// @ is an alias to /src
import AlipayService from '@/services/AlipayService'
import { mapState, mapMutations, mapActions } from 'vuex'
import Logo from '@/components/wedgits/Logo'
import Avatar from '@/components/Avatar'
import Loading from '@/views/Loading'
import gsap from 'gsap'
import HomeSlides from '@/components/HomeSlides'
import SysBar from '@/components/SysBar'
import ResCard from '@/components/home/ResCard'
import LogoIcon from '@/components/wedgits/LogoIcon'
import HomeAvatar from '@/components/home/HomeAvatar'
import axios from 'axios'
import store from '@/store/app'
import PopupSingle from '@/components/wedgits/PopupSingle'
import CustomService from '@/components/wedgits/CustomService'
import QueuePanel from '@/components/home/QueuePanel'
import InvPopup from '@/components/home/InvPopup'
import LatestResPopup from '@/components/home/LatestResPopup'
import CharityPopup from '@/components/wedgits/CharityPopup'
export default {
  name: 'Home',
  components: {
    CharityPopup,
    LatestResPopup,
    InvPopup,
    QueuePanel,
    CustomService,
    PopupSingle,
    HomeAvatar,
    LogoIcon,
    ResCard,
    SysBar,
    HomeSlides,
    Loading,
    Avatar,
    Logo,
  },
  data() {
    return {
      animeEl: {},
      authenticated: false,
      active: false,
      tl: null,
      showWarning: false,
      invPending: false,
      authSuccess: false,
    }
  },
  computed: {
    ...mapState('app', [
      'loading',
      'sysInfo',
      'resize',
      'user',
      'ageWarning',
      'ageWarningShowed',
      'pending',
      'showInvPopup',
      'invCode',
      'showLatestResPopup',
      'showCharityPopup',
    ]),
    loaded() {
      //return this.loading.completed
      return true
    },
  },
  created() {
    this.setPending(true)
  },
  mounted() {
    //console.log(window.my)
    console.log('home mounted')
    let prod = process.env.NODE_ENV === 'production'
    console.log(prod)
    if (prod) {
      AlipayService.sendMessage({ msg: AlipayService.Events.H5_LOADED })
      //AlipayService.sendEvent(AlipayService.Events.H5_LOADED)
      AlipayService.on(AlipayService.Events.ONMESSAGE, this.onMessage)
    } else {
      setTimeout(() => {
        this.updateUserInfo({
          avatar:
            'https://tfs.alipayobjects.com/images/partner/T1EJxfXiRmXXXXXXXX',
          nickname: 'James',
          //id: '1596549445150318610',
          id: '16165794281353276',
          grade: 'diamond',
          famUsers: [
            {
              avatar:
                'https://tfs.alipayobjects.com/images/partner/T1EJxfXiRmXXXXXXXX',
              nickname: 'James',
              userType: 0,
            },
            {
              avatar:
                'https://tfs.alipayobjects.com/images/partner/T1EJxfXiRmXXXXXXXX',
              nickname: 'James',
              userType: 2,
            },
          ],
          reses: [],
          userType: 0,
          tickets: [
            {
              access: 'part',
              childDiscount: 0.5,
              gradeLimit: 'all',
              ticketId: 1,
              ticketMoney: 0,
              ticketName: '探店模式',
              ticketPoint: 88,
              ticketStatus: 0,
            },
            {
              access: 'all',
              childDiscount: 0.5,
              gradeLimit: 'platinum,diamond',
              ticketId: 3,
              ticketMoney: 20,
              ticketName: '套票模式',
              ticketPoint: 88,
              ticketStatus: 0,
            },
          ],
          baseInfoRegistered: true,
          faceInfoRegistered: true,
        })
        this.setPending(false)
        this.init()
        this.animeIn()
      }, 2000)
    }

    // if (!this.loaded) {
    //   this.load()
    // } else {
    //   this.active = true
    // }
    //this.loaded = true
    //this.initAnimeEl()
    //this.initTimeline()
    // axios
    //   .get('http://api.panstone.group:8888/client/invQRCode?userId=111')
    //   .then((response) => {
    //     // handle success
    //     console.log(response)
    //   })
    //   .catch((error) => {
    //     // handle error
    //     console.log(error)
    //   })
    //   .then(() => {
    //     // always executed
    //   })
    // this.init()
    // this.animeIn()
  },
  watch: {
    // user: {
    //   handler(newVal) {
    //     console.log('user set')
    //     if (newVal.nickname !== '') {
    //       this.animeIn()
    //     }
    //   },
    //   deep: true,
    // },
  },
  methods: {
    ...mapActions('app', ['InvConfirm', 'GetUser', 'InvReject']),
    ...mapMutations('app', [
      'setLoadComplete',
      'updateUserInfo',
      'ageWarningConfirm',
      'showAgeWarning',
      'setRouterBack',
      'setPending',
      'setInvInfo',
      'invInfoClear',
    ]),
    fetchUserInfo() {
      this.setPending(true)
      this.GetUser(this.user.id)
        .then(() => {
          this.setPending(false)
        })
        .catch((err) => {
          console.log(err)
          this.setPending(false)
        })
    },

    pxToRem(px) {
      return `${px * 0.01}rem`
    },
    initAnimeEl() {
      this.animeEl.logoIcon = this.$refs.logoIcon
      this.animeEl.logo = this.$refs.logo
      this.animeEl.avatar = this.$refs.avatar
      this.animeEl.resCard = this.$refs.resCard
      this.animeEl.homeSlides = this.$refs.homeSlides
    },
    init() {
      this.initAnimeEl()
    },
    animeIn() {
      let tl = gsap.timeline({
        onComplete: () => {
          this.active = true
        },
      })
      tl.call(this.animeEl.logo.animeIn(1), [], 0.5)
      tl.call(this.animeEl.logoIcon.animeIn, [], 1)
      tl.call(this.animeEl.avatar.animeIn, [], 1.1)
      tl.call(this.animeEl.resCard.animeIn, [], 2.0)
      tl.call(this.animeEl.homeSlides.animeIn, [], 2.0)
      this.tl = tl
    },

    onMessage(e) {
      console.log('home recieve', e)
      if (e.msg === AlipayService.Events.USER_INFO_UPDATE) {
        console.log('user info: ', e)
        this.updateUserInfo(e.data.user)
        if (this.pending) {
          this.setPending(false)
          this.init()
          this.animeIn()
        }

        if (this.invPending) {
          if (e.data.user.userType === 0) {
            this.proceedInvConfirm()
            this.invPending = false
          }
        }
      }

      if (e.msg === AlipayService.Events.INV_POPUP) {
        console.log('got invitation', e)
        this.setInvInfo({
          invCode: e.data.invCode,
          inviter: e.data.inviter,
        })
      }

      if (e.msg === AlipayService.Events.ADD_CHILD_RESPONSE) {
        this.setPending(true)
        this.fetchUserInfo()
      }

      if (e.msg === AlipayService.Events.GET_PHONE_NUMBER_COMPLETE) {
        localStorage.setItem('getPhoneNumberComplete', '1')
        this.authSuccess = true
      }

      if (e.msg === AlipayService.Events.TO_MONSTER_PAGE) {
        console.log('H5 to monster page')
        this.$router.replace('/space/sticker')
        this.setRouterBack('/')
      }
      console.log(e.msg)
    },

    onAgeConfirm() {
      this.ageWarningConfirm()
      this.$router.replace('/reservation')
      this.setRouterBack('/')
    },
    onConfirm() {
      this.ageWarningConfirm()
    },
    onConfirm2() {
      this.authSuccess = false
    },
    onRes() {
      // if (!this.ageWarningShowed) {
      //   this.showAgeWarning()
      //   return
      // }
      this.$router.replace('/reservation')
      this.setRouterBack('/')
    },

    onInvAccepted() {
      if (this.user.userType !== 0) {
        AlipayService.sendEvent(AlipayService.Events.USER_AUTH_REQUEST)
        this.invPending = true
      } else {
        this.proceedInvConfirm()
      }
    },
    onInvRejected() {
      this.InvReject(this.invCode)
      this.invInfoClear()
    },

    proceedInvConfirm() {
      this.InvConfirm({
        userId: this.user.id,
        invCode: this.invCode,
      })
      this.invInfoClear()
    },
  },
}
</script>
<style lang="sass">
@import "src/styles/common.sass"
.home
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%
  overflow: hidden
  .container
    width: 100%
    height: 100%
    background-image: url("~assets/bg.png")
    background-size: pxToRem(57) pxToRem(57)
    pointer-events: none
    &.active
      pointer-events: all
    .up
      width: 100%
      height: 24%
      //background: #ff4d69
      display: flex
      justify-content: space-between
      align-items: center
      flex-direction: column
      //.system-bar
        width: 100%
        height: pxToRem(88)
        background: aqua
      .header
        //background: #3a602e
        position: relative
        width: 100%
        //padding: 0 pxToRem(40)
        height: pxToRem(166)
        .logo-wrapper
          display: flex
          flex-direction: row
          justify-content: center
          align-items: baseline
          //background: #e2bf65
          width: pxToRem(439)
          height: pxToRem(166)
          .logo-icon
            width: pxToRem(177)
            height: pxToRem(166)
          .logo
            position: relative
            top: pxToRem(-5)
            margin-left: pxToRem(33)
            width: pxToRem(259)
            height: pxToRem(75)
        .avatar
          //opacity: 0
    .bottom
      opacity: 1
      width: 100%
      height: 76%
      //background: #3a54a2
      display: flex
      justify-content: center
      align-items: center
      .content
        width: 100%
        //padding: 0 pxToRem(40)
        .reservation
          width: 100%
          height: pxToRem(480)

        .slides
          margin-top: pxToRem(54)
          width: 100%
          height: pxToRem(430)
          //background: #7bb9aa
          .home-slides
            width: 100%
            height: 100%
@keyframes fadeIn
  0%
    opacity: 0
  100%
    opacity: 1
@keyframes CardFadeIn
  0%
    opacity: 0
    transform: scale(0.75) translateY(30%)
  100%
    opacity: 1
    transform: scale(1) translateY(0)
</style>
